import React, { FC } from 'react';

import { useModals } from '@contexts/common/ModalContext';

import WrongNetworkModal from '@modules/modals/common/WrongNetworkModal';
import BuyOrderModal from '@modules/modals/fusion/BuyOrderModal';
import SellOrderModal from '@modules/modals/fusion/SellOrderModal';

import { MODAL_TYPES } from '@constants/common/modals.constants';

import { BuyOrderModalProps } from '@app-types/common/modal.types';

const Modals: FC = () => {
  const { state } = useModals();

  return (
    <>
      {state.current === MODAL_TYPES.WRONG_NETWORK_MODAL && (
        <WrongNetworkModal />
      )}
      {state.current === MODAL_TYPES.MARKETPLACE_BUY_ORDER_MODAL && (
        <BuyOrderModal {...(state.props as BuyOrderModalProps)} />
      )}
      {state.current === MODAL_TYPES.MARKETPLACE_SELL_ORDER_MODAL && (
        <SellOrderModal />
      )}
    </>
  );
};

export default Modals;
